<template>
  <div>
    <div class="plan-switcher">
      <div
        v-for="item in isGlobalVersion() ? plans : normals"
        :key="item.key"
        :class="[
          item.key,
          {
            active: state.cycle === item.key,
          },
        ]"
        class="text-font-60"
        @click="() => actionUpdateCycle(item.key)"
      >
        {{ item.label }}
        <span
          v-if="item.key === 'annual' && isGlobalVersion()"
          class="discount"
        >
          <span class="text">-20%</span>
        </span>
        <!-- <IconDiscounts
          v-if="item.key === 'annual' && isGlobalVersion()"
          filled
          class="xmov-icon discounts w-[50px] h-[20px]"
        /> -->
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { actionUpdateCycle } from '~/composables/rights'
import IconDiscounts from '~/assets/svg/discounts.svg?component'

const state = useRightsConfig()

const { $t } = useNuxtApp()

const plans = [
  {
    key: 'annual',
    label: $t('nian-du-ding-yue'),
  },
  {
    key: 'monthly',
    label: $t('yue-du-ding-yue'),
  },
]

const normals = [
  {
    key: 'person',
    label: $t('ge-ren'),
  },
  {
    key: 'team',
    label: $t('tuan-dui'),
  },
]
</script>

<style lang="scss" scoped>
.plan-switcher {
  width: 383px;
  height: 56px;
  padding: 4px 5px;
  background: #c1d6f2;
  border-radius: 28px;
  margin: 0 auto 0px;
  font-weight: 600;
  font-size: 18px;
  display: flex;
  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 28px;
    cursor: pointer;
    &.active {
      @apply text-font-1 font-medium;
      background: white;
      border-radius: 28px;
      font-weight: 900;
      .discounts {
        color: #ffd63e;
      }
    }
    &:hover {
      @apply text-font-1;
    }
  }

  .annual {
    width: 210px;
    .discounts {
      margin-left: 6px;
      color: #ff8e71;
    }
  }
  .monthly,
  .person,
  .team {
    width: 186px;
  }

  .discount {
    @apply flex-y-center justify-center ml-[8px];
    width: 48px;
    height: 24px;
    background: radial-gradient(116% 67% at 50% 50%, #cfcdff 0%, #ffffff 100%);
    border-radius: 12px;
    .text {
      display: inline-block;
      background: linear-gradient(
        226deg,
        #6bc9fd 0%,
        #7c4dff 55%,
        #f57a6a 100%
      );
      font-size: 12px;
      text-align: center;
      font-weight: bold;
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
}
// .plan-switcher {
//   width: 364px;
//   // height: 48px;
//   // background: #ffffff;
//   // border-radius: 28px;
//   // border: 1px solid var(--purple-4);
//   margin: 0 auto 0px;
//   font-weight: 500;
//   font-size: 18px;
//   // color: ;
//   display: flex;
//   @apply flex-y-center gap-[30px] justify-center text-font-70;
//   > div {
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     font-size: 30px;
//     font-weight: bold;
//     padding: 16px;
//     border-bottom: 4px solid transparent;
//     // border-radius: 28px;
//     cursor: pointer;
//     &.active {
//       color: var(--purple-6);
//       border-bottom: 4px solid var(--purple-6);
//     }
//   }
// }
</style>
